import { defineStore } from "pinia";
import { ref } from "vue";
// @ts-ignore
import { WorkerStore } from "simple-worker-vite";

export const useWorkerStore = defineStore("operator-worker", () => {
	const pluginWorkerStore = ref(new WorkerStore());
	const count = ref({
		highlight: 0,
		bubbly: 0,
	});
	const maxWorkers = ref({
		highlight: 32,
		bubbly: 16,
	});
	const waitingList = ref<{ [key: string]: Function[] }>({});

	async function spawn(name: "highlight" | "bubbly") {
		if (count.value[name] < maxWorkers.value[name]) {
			count.value[name]++;
			let worker = await pluginWorkerStore.value.spawn(name);
			if (worker) {
				return worker as Worker;
			}
		} else {
			return new Promise((resolve) => {
				if (!waitingList.value[name]) waitingList.value[name] = [];
				waitingList.value[name].push(() => {
					resolve(spawn(name));
				});
			});
		}
	}

	function releaseWorker(name: "highlight" | "bubbly") {
		count.value[name]--;
		if (!waitingList.value[name]) return;
		if (waitingList.value[name].length > 0) {
			const nextSpawn = waitingList.value[name].shift();
			if (nextSpawn) {
				nextSpawn();
			}
		}
	}

	return {
		spawn,
		releaseWorker,
	};
});
